import { APIClient } from "api/api_helper";
import { DISPENSING_API } from "api/url_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";

const api = new APIClient();

export const dispensingService = {
    insert: (payload: any) => {
        const user = GetUserData() as CurrentUser;
        return api.create(DISPENSING_API.DISPENSING_API + "Insert", {
            ...payload,
            createdby: user.userid,
            status:    "A",
        });
    },

   selectAll: (payload: any) => {
    return api.create(DISPENSING_API.DISPENSING_API + "SelectAll", {
        ...payload,  
    });
    },

    select: (payload: any) => {
        return api.create(DISPENSING_API.DISPENSING_API + "Select", {
            ...payload, 
        });
    },

    update: (payload: any) => {
        const user = GetUserData() as CurrentUser;
        return api.create(DISPENSING_API.DISPENSING_API + "Update", {
            ...payload,
            updatedby: user.userid,    
        });
    },

    delete: (payload: any) => {
        const user = GetUserData() as CurrentUser;
        return api.create(DISPENSING_API.DISPENSING_API + "Delete", {
            ...payload,
            updatedby: user.userid,   
        });
    },

    dropdown: () => {
        return api.create(DISPENSING_API.DISPENSING_API + "Dropdown", {});
    },

    IPDropdown: (payload: any) => {
        return api.create(DISPENSING_API.DISPENSING_API + "IPDropdown", {
            ...payload
        });
    },

    verifyPin: (payload: { verifypin: string, dispensingid: number , studyid: number , verifiedby: number }) => {
        return api.create(DISPENSING_API.DISPENSING_API + "Verify", payload);
    },

};